/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamPlayerVerificationStatus } from './PamPlayerVerificationStatus';
import {
    PamPlayerVerificationStatusFromJSON,
    PamPlayerVerificationStatusFromJSONTyped,
    PamPlayerVerificationStatusToJSON,
} from './PamPlayerVerificationStatus';

/**
 * A row in the back-office document review queue: an un-approved player with uploaded
 * documents, ordered by earliest upload. `verificationStatus` is null for a player who
 * has never started verification.
 * @export
 * @interface PamDocumentQueueSummary
 */
export interface PamDocumentQueueSummary {
    /**
     * 
     * @type {Date}
     * @memberof PamDocumentQueueSummary
     */
    firstDocumentAt: Date;
    /**
     * 
     * @type {number}
     * @memberof PamDocumentQueueSummary
     */
    documentCount: number;
    /**
     * 
     * @type {PamPlayerVerificationStatus}
     * @memberof PamDocumentQueueSummary
     */
    verificationStatus?: PamPlayerVerificationStatus | null;
    /**
     * 
     * @type {string}
     * @memberof PamDocumentQueueSummary
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamDocumentQueueSummary
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamDocumentQueueSummary
     */
    firstName?: string | null;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof PamDocumentQueueSummary
     */
    pamPlayerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof PamDocumentQueueSummary
     */
    customerId: string;
}



/**
 * Check if a given object implements the PamDocumentQueueSummary interface.
 */
export function instanceOfPamDocumentQueueSummary(value: object): value is PamDocumentQueueSummary {
    if (!('firstDocumentAt' in value) || value['firstDocumentAt'] === undefined) return false;
    if (!('documentCount' in value) || value['documentCount'] === undefined) return false;
    if (!('pamPlayerId' in value) || value['pamPlayerId'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    return true;
}

export function PamDocumentQueueSummaryFromJSON(json: any): PamDocumentQueueSummary {
    return PamDocumentQueueSummaryFromJSONTyped(json, false);
}

export function PamDocumentQueueSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamDocumentQueueSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'firstDocumentAt': (new Date(json['firstDocumentAt'])),
        'documentCount': json['documentCount'],
        'verificationStatus': json['verificationStatus'] == null ? undefined : PamPlayerVerificationStatusFromJSON(json['verificationStatus']),
        'email': json['email'] == null ? undefined : json['email'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'pamPlayerId': json['pamPlayerId'],
        'customerId': json['customerId'],
    };
}

export function PamDocumentQueueSummaryToJSON(value?: PamDocumentQueueSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstDocumentAt': ((value['firstDocumentAt']).toISOString()),
        'documentCount': value['documentCount'],
        'verificationStatus': PamPlayerVerificationStatusToJSON(value['verificationStatus']),
        'email': value['email'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'pamPlayerId': value['pamPlayerId'],
        'customerId': value['customerId'],
    };
}

